export default "__VITE_ASSET__C9SW0nQ4__"